import React from 'react'
import PropTypes from 'prop-types'
import FormInput from 'components/forms/bases/FormInput'
import FormLabel from 'components/labels/FormLabel'
import omit from 'lodash/omit'

const FormTextInput = ({ label, value, onChange, ...otherProps }) => (
  <div>
    <FormLabel>{label}</FormLabel>
    <FormInput
      placeholder={'Latitude'}
      value={value.lat}
      onChange={(val) => { onChange({ ...value, lat: val }) }}
      {...omit(otherProps, ['placeholder'])}
    />
    <FormInput
      placeholder="Longitude"
      value={value.lng}
      onChange={(val) => { onChange({ ...value, lng: val }) }}
      {...omit(otherProps, ['placeholder'])}
    />
  </div>
)

FormTextInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.shape({
    lat: PropTypes.number,
    png: PropTypes.number,
  }),
  onChange: PropTypes.func,
}
FormTextInput.defaultProps = {
  label: '',
  value: {
    lat: undefined,
    lng: undefined,
  },
  onChange: () => {},
}

export default FormTextInput



// WEBPACK FOOTER //
// ./src/components/forms/FormLocation.js